import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ReasonCode } from '@assess/browser/api';
import { Nullable } from '@assess/shared/type-utilities';

@Component({
  selector: 'assess-reason-code-chip',
  templateUrl: './reason-code-chip.component.html',
  styleUrls: ['./reason-code-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasonCodeChipComponent {
  @Input() reasonCode!: Nullable<Pick<ReasonCode, 'label' | 'secondaryType'>>;
  color!: string;
}
